module.exports = __webpack_public_path__ + "img/for-shippers.bc4379a.png";